<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     备案查询内容
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="record-check-content">
    <div v-if="step == 1" class="flex align-items-center column">
      <div class="title text-bold">
        备案查询
      </div>
      <div class="search">
        <el-input v-model="keyword" class="search-input" placeholder="公司名称" @keyup.enter.native="handleSearch">
        </el-input>
        <div role="button" class="append flex-center" @click="handleSearch">查 询</div>
        <search-content ref="searchSelect" :keyword="keyword" :height="320" @select="handleSelect" />
      </div>
    </div>

    <div v-if="step == 2" class="flex align-items-center column">
      <div class="title text-bold" :style="{ marginBottom: type == 'dialog' ? '20px' : '20px' }">
        查询结果
      </div>
      <el-card style="position: relative;width: 600px;height: 360px;">
        <el-form
          label-position="left"
          label-width="120px"
          style=" margin: 10px 50px;">
          <el-form-item label="公司名称">
            {{ result.company_name }}
          </el-form-item>
          <el-form-item label="信用代码">
            {{ result.credit_code }}
          </el-form-item>
          <el-form-item label="备案状态">
            <div :class="{ 'text-primary': is_exist && result.is_self, 'text-danger': is_exist && !result.is_self, 'text-blue': !is_exist}">{{ is_exist ? '已报备' : '未报备' }}</div>
          </el-form-item>
          <el-form-item v-if="is_exist" label="服务伙伴">
            {{ result.is_self ? result.full_name : result.god_code }}
          </el-form-item>
          <el-form-item v-if="is_exist" label="报备日期">
            {{ result.report_time | parseTime('{y}/{m}/{d}') }}
          </el-form-item>
          <el-form-item v-if="is_exist && !result.is_customer" label="保护期限">
            {{ result.protection_expiretime | parseTime('{y}/{m}/{d}') }}
            <span class="text-warning ml-sm">剩余{{ days }}天</span>
          </el-form-item>
        </el-form>

        <div class="card-ft flex-center">
          <el-button plain @click="step = 1">再次查询</el-button>
          <el-button v-if="!is_exist" type="primary" @click="toReport">立即报备</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>

import { companyCheckApi } from '@/api/prm/prmApi'
export default {
  name: 'RecordCheckContent',

  components: {
    SearchContent: () => import('./SearchContent'),
  },

  props: {
    companyid: {
      type: Number,
      default: 0
    },

    type: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      step: 1,
      loading: false,
      keyword: '',
      clueCompany: {},
      result: {},
      is_exist: false,
      days: 0
    }
  },

  computed: {
  },

  created() {
  },

  watch: {
  },

  methods: {
    toReport() {
      this.$emit('report', this.clueCompany)
    },

    handleSearch() {
      this.$refs.searchSelect.handleSearch()
    },

    handleSelect(val) {
      this.keyword = val.name
      this.clueCompany = Object.assign({}, val)
      this.checkCompany(val.company_id)
    },

    checkCompany(id) {
      companyCheckApi({
        company_id: id
      }).then((res) => {
        if (!res.errno) {
          this.is_exist = res.data.is_exist
          this.result = Object.assign({}, res.data.detail)
          const today = new Date(new Date().toLocaleDateString()).getTime() / 1000
          this.days = parseInt((this.result.protection_expiretime - today) / 86400)
          this.step = 2
        } else {
          this.$message.error(res.message);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item {
  margin-bottom: 10px;
}
.custom-option {
  /* 允许内部内容换行 */
  white-space: normal !important;
  /* 增加选项高度，适配双行 */
  height: auto !important;
  padding: 8px 16px !important;
  line-height: 1.5 !important;
}
.record-check-content {
  width: 900px;
  margin: 0 auto;
  .title {
    font-size: 42px;
    padding: 20px 0;
  }
  .search {
    position: relative;
    width: 900px;
    height: 60px;
    .search-input {
      /* 下拉面板整体样式 */
      
      /deep/ .el-input__inner {
        height: 60px;
        line-height: 60px;
        font-size: 18px;
        border: 1px solid rgba(7,193,96,1);
        border-radius: 60px;
        padding-left: 30px;
      }
      /deep/ .el-input__suffix-inner .el-icon-circle-close {
        font-size: 24px;
        line-height: 60px;
        color: #999;
        margin: 0px 130px 0;
        display: block;
      }
    }
   .append {
      position: absolute;
      right: 5px;
      top: 5px;
      bottom: 5px;
      color: #fff;
      background-color: rgba(7,193,96,1);
      border: 0;
      border-radius: 50px;
      width: 120px;
      text-align: center;
      font-size: 16px;
      margin-left: -120px;
    }
  }
  .card-ft {
    position: absolute;
    bottom: 20px;
    left: 20px;
    right: 20px;
  }
}
</style>